var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('canvas',{ref:"canvas",attrs:{"width":_vm.canvasWidth2,"height":_vm.canvasHeight2}})])
}
var staticRenderFns = []

export { render, staticRenderFns }